module.exports = __webpack_public_path__ + "img/Footer_Page.beba1e39.png";